module.exports = __webpack_public_path__ + "assets/img/drawItem6-e1be29df.png";